import { ReferanceAsyncSelect } from './referance-async-select'

export function SelectReferanceCode2({ name, brannd }) {
  return (
    <ReferanceAsyncSelect
      name={name}
      labelCategory={brannd === 'ZaraHome' ? 'TRIMAN ETİKETİ' : 'UYARI ETİKETİ'}
    />
  )
}
